var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("BaseBulkMessageListItem", {
    directives: [
      {
        name: "loading",
        rawName: "v-loading",
        value: _vm.isBusy,
        expression: "isBusy",
      },
    ],
    attrs: { "is-current": _vm.isCurrent },
    scopedSlots: _vm._u([
      {
        key: "badges",
        fn: function () {
          return [
            _c("Badge", { attrs: { type: "email" } }),
            _vm._v(" "),
            _vm.isDraft
              ? _c("Badge", { attrs: { type: "draft" } })
              : _vm.isQueued
              ? _c("Badge", {
                  attrs: { type: "queued", text: _vm.badgeQueuedText },
                })
              : _vm.isScheduled
              ? _c("Badge", {
                  attrs: { type: "scheduled", text: _vm.badgeSchedulesText },
                })
              : _vm.isSent
              ? _c("Badge", {
                  attrs: { type: "sent", text: _vm.badgeSentText },
                })
              : _vm.isCanceled
              ? _c("Badge", { attrs: { type: "canceled" } })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "menu",
        fn: function () {
          return [
            _vm.isSent || _vm.isCanceled
              ? _c(
                  "div",
                  {
                    staticClass: "dropdown-item",
                    on: { click: _vm.showMessages },
                  },
                  [_vm._v("Show messages")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isCancelable && _vm.canUpdate
              ? _c(
                  "div",
                  {
                    staticClass: "dropdown-item",
                    on: { click: _vm.cancelSending },
                  },
                  [_vm._v("Cancel")]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "header",
        fn: function () {
          return [
            _c("span", { staticClass: "font-weight-bold" }, [
              _vm._v(_vm._s(_vm.subject)),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [_c("div", { domProps: { innerHTML: _vm._s(_vm.emailBody) } })]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }